/**************************************************
 * Nombre:       Dialogo_Movimientos_Crear
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import Formulario_Movimientos_Crear from "../Formularios/Formulario_Movimientos_Crear";
import {useEffect} from "react";
import {adap_crear_mov} from "../../CodNegocio/Adaptadores/adap_crear_mov";

const Dialogo_Movimientos_Crear = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionDos: realizado,
        funcionUno: cerrar,
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        console.log(entidad)
        iniciarCarga('Creando Movimiento')

        if (entidad.idEscogido === datos.minContrato) {
            entidad.idContrato = datos.idContrato
        }else{
            delete entidad.idContrato
        }

        let doxConse = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
        let consecutivo = doxConse.data
        let movimiento = adap_crear_mov(entidad, consecutivo)
        movimiento.estado = entidad.estado

        let dox = await guardarDoc('movimientos', movimiento)
        if (dox.res) {
            await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: consecutivo})
            terminar({aviso: 'Movimiento realizado'})
        } else {
            terminar({aviso: 'No se realizo el movimiento, verifica e intentalo nuevamente', variante: 'error'})
        }


    }


    useEffect(() => {

    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Movimientos_Crear props={props} opciones={[datos.minContrato]}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Movimientos_Crear